import React, { Component, Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { Form } from 'informed'

import StatisticsWrapper from './StatisticsWrapper'
import { DataTable } from 'components//DataTable'
import { DateTimePicker, FieldList } from 'components/forms'
import Button from 'components/Button'
import Card from 'components/Card'
import Divider from 'components/Divider'
import tableDataGenerator from 'helpers/tableDataGenerator'

import './statistics.scss'

const columns = [
		{ Header: 'id', accessor: 'id', show: false },
		{ Header: 'Bereich', accessor: 'date' },
		{ Header: 'Zeit', accessor: 'time' },
		{ Header: 'Buchungsart', accessor: 'bookingType' },
		{ Header: 'Benutzername', accessor: 'name' },
		{ Header: 'Filiale', accessor: 'filial' },
		{ Header: 'Kasse', accessor: 'cashbox' }
	],
	colsSecondary = [
		{ Header: 'id', accessor: 'id', show: false },
		{ Header: 'Datum', accessor: 'date' },
		{ Header: 'Zeit', accessor: 'time' },
		{ Header: 'Art', accessor: 'type' },
		{ Header: 'Operation', accessor: 'operation' },
		{ Header: 'Benutzername', accessor: 'name' },
		{ Header: 'Feld', accessor: 'field' },
		{ Header: 'Alter Wert', accessor: 'oldValue' },
		{ Header: 'Neuer Wert', accessor: 'newValue' },
		{ Header: 'Feldname in DB', accessor: 'fieldDB' },
		{ Header: 'Inhalt', accessor: 'content' }
	]

class Employees extends Component {
	state = {
		showStatistics: false,
		values: {}
	}

	handlerDataStatisticsSubmit = () => {
		this.setState({ showStatistics: true })
	}

	handleAddFieldListItem = (field, items, valFromOptions = true) => {
		const { values } = this.state,
			newValues = items.map((item, i) => {
				let formData
				if(valFromOptions) {
					// formData = itemInArrObjsByValue(item, dataProductList(20), 'id')
				} else {
					const strVal = typeof item === 'object' ?
						Object.values(item).join(' - ') : item

					formData = { id: Math.floor(Math.random() * 100), value: strVal }
				}

				return formData
			})

		this.setState({
			values: {
				...values,
				[field]: valFromOptions ? newValues : [...values[field] || [], ...newValues]
			}
		})
	}

	handleDelFieldListItem = ({ field, value }) => {
		this.setState({
			values: {
				...this.state.values,
				[field]: this.state.values[field].filter(item => item.id !== value)
			}
		})
	}

	toggleAddingRow = () => this.setState({ addingRow: !this.state.addingRow })

	render({ values } = this.state) {
		const formStatistics = (
			<Form render={({ formState }) => (
				<Fragment>
					<Row>
						<Col xs={2} style={{ flexBasis: '14%' }}>
							<DateTimePicker field='date' label='Bereich' />
						</Col>
						<Col xs={4}>
							<DateTimePicker
								field='type'
								interval
								picker='time'
								label={{ from: 'Ab Zeit', to: 'Bis Zeit' }} />
						</Col>
					</Row>
					<Divider visible />
					<Row className='statistics-form-card'>
						<Col xs={3}>
							<Card
								id='cashBoxList'
								label='Kassen'
								noDataText='Kassen abwesend'
								listContent
								modal={{
									content: <React.Fragment />,
									width: 820
								}}>
								{(values.cashBoxList && values.cashBoxList.length) &&
									<FieldList listItems={values.cashBoxList} field='cashBoxList' onDelItem={this.handleDelFieldListItem} />
								}
							</Card>
						</Col>
						<Col xs={3}>
							<Card
								id='usersList'
								label='Benutzer'
								noDataText='Benutzer abwesend'
								listContent
								modal={{
									content: <React.Fragment />,
									width: 820
								}}>
								{(values.cashBoxList && values.cashBoxList.length) &&
									<FieldList listItems={values.cashBoxList} field='usersList' onDelItem={this.handleDelFieldListItem} />
								}
							</Card>
						</Col>
					</Row>
					<Divider />
					<Button onClick={this.handlerDataStatisticsSubmit} text='Berechnen' status='primary' />
				</Fragment>
			)}/>
		)

		return(
			<StatisticsWrapper statisticsData={formStatistics} showStatistics={this.state.showStatistics} switchLabel='Erweitern Filialen ohne daten'>
				{this.state.showStatistics &&
					<div>
						<DataTable
							data={tableDataGenerator(columns, 20)}
							columns={columns}
							withSearch
							mutateRow={{
								isMutating: this.state.mutatingMain,
								toggleMutation: () => this.setState({ mutatingMain: !this.state.mutatingMain })
							}}
							style={{ maxHeight: '520px' }}
						/>
						<Divider />
						<div>
							<Button text='hinzufügen' status='primary' onClick={e => this.setState({ mutatingMain: true })} />
						</div>
					</div>
				}
				{this.state.showStatistics &&
					<div>
						<DataTable
							data={[]}
							columns={colsSecondary}
							mutateRow={{
								isMutating: this.state.mutatingSecondary,
								toggleMutation: () => this.setState({ mutatingSecondary: !this.state.mutatingSecondary })
							}}
							label='Verlauf'
						/>
						<Divider />
						<div>
							<Button text='hinzufügen' status='primary' onClick={e => this.setState({ mutatingSecondary: true })} />
						</div>
					</div>
				}
			</StatisticsWrapper>
		)
	}
}

export default Employees
